import * as React from "react"

import type { BookId } from "@/lib/types"

interface BooksFiltersValue {
  book: BookId
  setBook: (book: BookId) => void
  from: string
  setFrom: (value: string) => void
  to: string
  setTo: (value: string) => void
}

const BooksFiltersContext = React.createContext<BooksFiltersValue | null>(null)

export function BooksFiltersProvider({ children }: { children: React.ReactNode }) {
  const [book, setBook] = React.useState<BookId>("STATUTORY_PE")
  const [from, setFrom] = React.useState("2026-07-01")
  const [to, setTo] = React.useState("2026-07-31")

  const value = React.useMemo(
    () => ({ book, setBook, from, setFrom, to, setTo }),
    [book, from, to],
  )

  return <BooksFiltersContext.Provider value={value}>{children}</BooksFiltersContext.Provider>
}

export function useBooksFilters() {
  const context = React.useContext(BooksFiltersContext)
  if (!context) throw new Error("useBooksFilters debe usarse dentro de <BooksFiltersProvider>.")
  return context
}
